import { z } from "zod";

export const editObservationSchema = z.object({
  code: z.object({
    coding: z.array(
      z.object({
        code: z.string(),
        display: z.string(),
        system: z.string(),
      }),
    ),
    text: z.string().optional(),
  }),
  observationValue: z.string().nonempty("Required"),
});
